export default function Badge({ className, children, ...props }) {
    return (
        <div className={`badge ${className}`} {...props}>
            {children}
        </div>
    );
}
